import classNames from "classnames";
import spinner from "shared/assets/icons/spinner.svg";
import {ImageContext} from "../../tools/image/imageContext";
import {useContext} from "react";
import "./loadingOverlay.scss";

export const LoadingOverlay = () => {
  const {loadingStatus} = useContext(ImageContext);
  return (
    <div className={classNames("loading-overlay", {active: loadingStatus})} style={{ display: "none" }}>
      <img src={spinner} alt="loading..."/>
    </div>
  )
}
